import {charcoal} from '../../sass/v2/_exports.sass';

export const CalendarAltIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7.99999V26.6667C4 27.3739 4.28095 28.0522 4.78105 28.5523C5.28115 29.0524 5.95942 29.3333 6.66667 29.3333H25.3333C26.0406 29.3333 26.7189 29.0524 27.219 28.5523C27.719 28.0522 28 27.3739 28 26.6667V7.99999C28 7.29275 27.719 6.61447 27.219 6.11437C26.7189 5.61427 26.0406 5.33332 25.3333 5.33332H22.6667V2.66666H20V5.33332H12V2.66666H9.33333V5.33332H6.66667C5.95942 5.33332 5.28115 5.61427 4.78105 6.11437C4.28095 6.61447 4 7.29275 4 7.99999ZM25.3333 26.6667H6.66667V10.6667H25.3333V26.6667Z"
        fill={color}
      />
    </svg>
  );
};
